<!-- Navigation Bar -->
<app-nav-bar></app-nav-bar>
<!-- Navbar End -->

<div appScrollspy [spiedTags]="['SECTION']">
  <!-- Hero Start -->
  <section class="hero-1-bg position-relative"
    style="background-image: url('../../../assets/images/tech-mesh.svg');background-size: cover;background-repeat: no-repeat;background-position: center;background-color:#000f66;">
    <div class="container">
      <div class="align-items-center active">
        <div class="w-75 mx-auto">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-12">
                <div class="text-center">
                  <h1 class="text-white hero-4-title font-weight-light line-height-1_4 mb-4">CONTACT US</h1>
                  <p class="text-white">Our team would love to hear from you</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%;margin-top: 6rem;">
      <svg viewBox="0 0 1440 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="718" cy="191" rx="959" ry="191" fill="white" />
      </svg>
    </div>
  </section>

  <app-contact></app-contact>
  <app-footer></app-footer>
